import { render, staticRenderFns } from "./MediaSelectorComponent.vue?vue&type=template&id=335996cf"
import script from "./MediaSelectorComponent.vue?vue&type=script&lang=js"
export * from "./MediaSelectorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports